module.exports = __webpack_public_path__ + "img/礼物.eb24e4a7.png";